export const errorCodeMsg = {
  400: "Si prega di contattare l'assistenza", // BAD REQUEST dovuta a sintassi non valida in richiesta sono fix da fare lato nostro
  404: "Si prega di contattare l'assistenza", // NOT FOUND dovuta a url non valida in richiesta sono fix da fare lato nostro
  408: "L'operazione ha impiegato troppo tempo. Si prega di riprovare più tardi", // REQUEST TIMEOUT
  413: "La dimensione del documento supera la dimensione massima consentita" // PAYLOAD TOO LARGE
};
